export default function setLocalStorage<T = Record<string, unknown>>(key: string, data: T) {
  localStorage.setItem(key, JSON.stringify(data));
}
